import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import './styles.scss';

const Publications = props => {
    return (
        <div className="publications">
            {props.publications && props.publications.map(publication => {
                return (
                    <Link key={`publication${publication.publicationId}`} to={`/publications/${publication.publicationId}`} className={classNames({
                        'publications__document': true,
                        'publications__document--no-access': !publication.userHasAccessToThisPublication
                    })}>
                        <div className="publications__document-img-container">
                            <div className="publications__document-icon"></div>
                            {publication.images && publication.images.length > 0 &&
                                <img className="publications__document-img" src={publication.images[0].filePath} alt ="" />
                            }
                        </div>
                        <div className="publications__document-date">{new Date(publication.publishedOn).toLocaleDateString('sv')}</div>
                        <h2 className="publications__document-heading">{publication.title}</h2>
                    </Link>
                );
            })}
        </div>
    );
};

export default Publications;